import { Account, LoggedUser } from '../../session/session-decode';
import { isIntegrator, isIntegratorOrDistributor } from '../../session/user-type';
import { hasPerm, Permission } from '../../session/permissions';

/** Mais de uma conta habilita a troca — com uma só não há para onde trocar. */
export function shouldShowAccountSelector(user: LoggedUser | null): boolean {
  return (user?.contas?.length ?? 0) > 1;
}

// A exclusão de contas ACCESS já foi aplicada pelo chamador antes de chegar aqui.
export function shouldShowIntegratorAccountSelector(eligibleAccounts: readonly Account[]): boolean {
  return eligibleAccounts.length > 1;
}

/** Some quando não há conta ativa ou na tela de cadastro de conta (ainda não há o que exibir). */
export function shouldShowAccountName(route: string, accountName: string | null): boolean {
  return !!accountName && !route.includes('add-conta');
}

export function shouldShowPerson(user: LoggedUser | null, hasTenant: boolean): boolean {
  if (!user) {
    return false;
  }
  return hasTenant && !isIntegratorOrDistributor(user);
}

/** Integrador vê os próprios dados mesmo sem conta; os demais, a partir da primeira conta. */
export function shouldShowMyData(user: LoggedUser | null): boolean {
  if (!user) {
    return false;
  }
  return isIntegrator(user) || (user.contas?.length ?? 0) >= 1;
}

/**
 * Uma única permissão é checada (UPDATE), espelhando o que o menu legado avalia de fato:
 * lá o `||` está dentro do argumento de hasPerm e colapsa para UPDATE antes da chamada.
 */
export function shouldShowSettings(
  user: LoggedUser | null,
  authorities: readonly string[],
): boolean {
  if (!user || isIntegratorOrDistributor(user)) {
    return false;
  }
  return hasPerm(Permission.CONFIGURACOES_UPDATE, authorities);
}

/** Conta ativa dá acesso à troca de senha; integrador/distribuidor tem acesso sem conta. */
export function shouldShowChangePassword(user: LoggedUser | null, hasTenant: boolean): boolean {
  return hasTenant || isIntegratorOrDistributor(user);
}
